import { combineReducers } from 'redux';
import maps from './index';

const appReducer = combineReducers({
  maps: maps,
});

export default appReducer;
